import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import "./DropzoneArchivos.css";

const MAX_TOTAL_SIZE_MB = 20;
const EXTENSIONES_PERMITIDAS = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "image/jpeg",
  "image/jpg",
  "image/png",
];

const DropzoneArchivos = ({ onFilesSelected, titulo = "Archivos adjuntos" }) => {
  const [archivos, setArchivos] = useState([]);
  const [error, setError] = useState(null);
  const [subiendo, setSubiendo] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    const totalSize = [...archivos, ...acceptedFiles].reduce((acc, file) => acc + file.size, 0);
  
    const archivosValidos = acceptedFiles.every((file) =>
      EXTENSIONES_PERMITIDAS.includes(file.type)
    );
  
    if (!archivosValidos) {
      setError("Solo se permiten archivos PDF, DOCX, JPG, JPEG y PNG.");
      return;
    }
  
    if (totalSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
      setError(`El tamaño total no debe superar los ${MAX_TOTAL_SIZE_MB} MB.`);
      return;
    }
  
    setError(null);
  
    // Elimina duplicados (por nombre y tamaño)
    const nuevosArchivos = acceptedFiles.filter(
      nuevo => !archivos.some(prev => prev.name === nuevo.name && prev.size === nuevo.size)
    );
  
    const archivosActualizados = [...archivos, ...nuevosArchivos];
  
    setArchivos(archivosActualizados);
    onFilesSelected(archivosActualizados);
  }, [archivos, onFilesSelected]);
  

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png']
    }
  });

  const handleEliminarArchivo = (index) => {
    const nuevosArchivos = [...archivos];
    nuevosArchivos.splice(index, 1);
    setArchivos(nuevosArchivos);
    onFilesSelected(nuevosArchivos);
  };

  return (
    <div className="rubro">
      <h3>{titulo}</h3>
      <div className="dropzone-container">
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Suelta los archivos aquí...</p>
          ) : (
            <p>Arrastra archivos o haz clic para seleccionar desde tu computadora</p>
          )}
        </div>

        {error && <div className="dropzone-error">{error}</div>}

        {archivos.length > 0 && (
          <div className="archivos-seleccionados">
            <p>Archivos seleccionados ({archivos.length}):</p>
            <ul>
              {archivos.map((file, index) => (
                <li key={index}>
                  <span>{file.name} ({(file.size / (1024 * 1024)).toFixed(2)} MB)</span>
                  <button 
                    type="button" 
                    onClick={() => handleEliminarArchivo(index)}
                    className="action-btn"
                  >
                    Eliminar
                  </button>
                </li>
              ))}
            </ul>
            
            {subiendo && (
              <div className="progreso-carga">
                <div className="progreso-carga-barra" style={{ width: "70%" }}></div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DropzoneArchivos;